import axios from 'axios'

const psyco = {
  getSpace (cb) {
    const promise = axios.get('https://api.psyco.fr/torrents/space')
    this.handleResponse(promise, cb)
  },

  handleResponse(promise, cb) {
    promise.then((resp) => {
      cb(resp)
    }).catch((error) => cb([]))
  },
}

export default psyco
